/**
 * @generated SignedSource<<5963940c4abe3ea0ef3d90eddcb73b85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type flagField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly " $fragmentType": "flagField_updateWorkItemAllFieldTypesActionRenderer";
};
export type flagField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: flagField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"flagField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "flagField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraFlagField"
};

(node as any).hash = "4eb8b9578220c67e9a4bd89c32e06374";

export default node;
